import {useEffect, useLayoutEffect, useRef} from "react";
import {CSSPlugin, gsap} from "gsap";
import {useLocation} from "react-router-dom";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {useSelector} from "react-redux";

export const Horizontal = () => {
    const location = useLocation();
    let getPost = useSelector(state => state)

    useEffect(() => {
        gsap.utils.toArray(".horizontal-scroll").forEach((item, i) => {
            let getTextRight = item.querySelector('.scroll-right')
            let getTextLeft = item.querySelector('.scroll-left')
            let parallaxSpeedRight = item.getAttribute('data-speed-up');
            let parallaxSpeedLeft = item.getAttribute('data-speed-down');

            gsap.to(getTextRight, {
                xPercent: parallaxSpeedRight ? parallaxSpeedRight : 50,
                ease: "none",
                scrollTrigger: {
                    trigger: item,
                    // start: "left 70%",
                    // end: "left 30%",
                    // horizontal: true,
                    // markers: true,
                    scrub: true
                }
            });

            gsap.to(getTextLeft, {
                xPercent: parallaxSpeedLeft ? parallaxSpeedLeft : -50,
                ease: "none",
                scrollTrigger: {
                    trigger: item,
                    // start: "left 70%",
                    // end: "left 30%",
                    // horizontal: true,
                    // markers: true,
                    scrub: true
                }
            });

            // t1.to(".box1", {
            //     scale: 2,
            //     rotation: 360,
            //     duration: 3
            // });

        });
    }, [location.pathname,getPost])

}



